import cn from 'classnames'
import React, { ComponentProps } from 'react'

type LineChartIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function LineChartIcon(props: LineChartIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('LineChartIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2 2V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H14"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6667 6L9.33341 9.33333L6.66675 6.66667L4.66675 8.66667"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
